import { ApiEndPoint } from "../../network/api_end_point";
import { apiCaller, getToken } from "../../network/network_helper";

const apiEndPoint = new ApiEndPoint();
export const driverDetailsApiCall = async (
  query,
  status,
  pageSize,
  currentPage
) => {
  try {
    const token = getToken();
    const channelId = localStorage.getItem('channelId');
    const params = {};
    if (query) {
      params.query = query;
    }
    if (status && status !== "All") {
      params.status = status.toLowerCase(); // Only add status if it's not "All"
    }
    if (pageSize) {
      params.page_size = pageSize;
    }
    if (currentPage) {
      params.page = currentPage;
    }
    params.source=apiEndPoint.source;

    const response = await apiCaller(
        `${apiEndPoint.masterUrlWithChannelId(channelId)}drivers`,

      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: params,
      }
    );
    return response;
  } catch (e) {
    throw e;
  }
};
export const wareHouseListApiCall = async () => {
  try {
    const token = getToken();
    const response = await apiCaller(
      apiEndPoint.authBaseUrl + apiEndPoint.warehouseUrl,

      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (e) {
    throw e;
  }
};
